module.exports = __webpack_public_path__ + "img/sol_cap1.7e5b1a0c.png";